import { useEffect, useState } from "react";
import PageHierarchy from "../page-hierarchy/page-hierarchy";
import "./shop-management.scss";
import { useDispatch, useSelector } from "react-redux";
import ShopTable from "../shop-table/shop-table";
import { deleteShop, getDetailedShops, getShopsByUser} from "../../shopSlices";
import NewShopPopup from "../new-shop-popup/new-shop-popup";
import ConfirmationPopup from "../confirmation-popup/confirmation-popup";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { createPaymentIntent } from "features/authentication/userSlices";
import PlanSelector from "../plan-selector/plan-selector";
import Payment from "../payment/payment";
import { v4 as uuidv4 } from 'uuid';
import SelectedShopLogo from "assets/side-bar/selected-shop.svg"
export enum PlanSelectorEnum {
  STANDARD = 'Standard',
  PRO = 'Pro'
}

const ShopManagement = () => {
    const dispatch: Function = useDispatch();
    const user = useSelector((state: any) => state.auth.user);
    const shops = useSelector((state: any) => state.shop.shops);
    const userStripeKey = useSelector((state: any) => state.user.userStripeSecretKey);
    const subscriptionId = useSelector((state: any) => state.user.subscriptionId);
    const shopToEditId = useSelector((state: any) => state.shop.shopToEdit);
    const shopToChangePlanId = useSelector((state: any) => state.shop.shopToChangePlan);
    const newShopDetails = useSelector((state: any) => state.shop.newShopDetails);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [wordToConfirm, setWordToConfirm] = useState(null)
    const [shopIdToDelete, setShopIdToDelete] = useState(null)
    const [stripePromise, setStripePromise] = useState(null);
    const [clientSecret, setClientSecret] = useState("");
    const [step, setStep] = useState(1);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const shopToChangePlan = shopToChangePlanId ? shops.find((shop) => shop.id === shopToChangePlanId) : null;
    const totalShops = shops.length;
    
    const shopTemplate = (option) => {
      if (!option) return null;
      return (
        <div className="shop" key={uuidv4()}>
          <img alt={option.name} src={SelectedShopLogo} />
          <div className="shop__details">
            <div className="shop__details__name">{option.name}</div>
            <div className="shop__details__address">{option.address}</div>
          </div>
        </div>
      );
    };
    useEffect(() => {
        dispatch(getShopsByUser(user.sub))
        dispatch(getDetailedShops())
    }, []);

    const createPayment = (plan) => {
      dispatch(createPaymentIntent(user.name, user.email, user.sub, plan))
    }

    useEffect(()=>{
      if(!userStripeKey)  
      setStripePromise(loadStripe('pk_live_51NrzYjCEH0k3l1HLTfVu9LVvcagicA0K9y2mXyXM16tMqDEjVpQ8kG4GfdRH3ht3T3OACir3Q6wBZ9fCpXqVWWzq00SMT2G48X'));
      setClientSecret(userStripeKey);
    },[userStripeKey])
    const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));
    const handleSelectedPlan = async (plan) => {
      createPayment(plan)
      await wait(2000)
      setSelectedPlan(plan)
    }
    const showPlanSelector = (step === 2);
    const showShopPopup = (isPopupOpen && step !== 2) || shopToEditId

    useEffect(() => {
      if(shopToChangePlan){
        setSelectedPlan(shopToChangePlan.plan)
      }
    }, [shopToChangePlan])
  return (
    <div className="shop-management">
      {showPlanSelector && 
        <div className="shop-management__choose-plan">
  
          
          {selectedPlan && stripePromise && clientSecret?
           <Elements stripe={stripePromise} options={{ clientSecret }}>
              <Payment setStep={setStep} selectedPlan={selectedPlan} setSelectedPlan={setSelectedPlan}/>
           </Elements>
           :
           <>
           <div className="shop-management__choose-plan__title">Choose your plan for</div>
           {shopTemplate(newShopDetails)}
          <div className="shop-management__choose-plan__plans">
            <PlanSelector title={PlanSelectorEnum.STANDARD} description="Ideal for managing inventory and tracking product consumption." price="79" details={['Unlimited editors', 'Stock management', 'Consumption tracking']} selected={selectedPlan} setSelected={handleSelectedPlan} setStep={setStep}/>
            <PlanSelector title={PlanSelectorEnum.PRO} description="Ideal for advanced insights into sales trends, optimizing inventory levels and orders." price="99" details={['Unlimited editors', 'Stock management', 'Consumption tracking', 'BI Dashboard', 'AI forecasting']} selected={selectedPlan} setSelected={handleSelectedPlan} setStep={setStep}/>
          </div>
          </>
          }
        </div>
      }
      {
        shopToChangePlan && selectedPlan && 
        <div className="shop-management__choose-plan">
          <div className="shop-management__choose-plan__title">Choose your plan for</div>
          {shopTemplate(shopToChangePlan)}
        <div className="shop-management__choose-plan__plans">
            <PlanSelector title={PlanSelectorEnum.STANDARD} description="Ideal for managing inventory and tracking product consumption." price="79" details={['Unlimited editors', 'Stock management', 'Consumption tracking']} selected={selectedPlan} setSelected={handleSelectedPlan} setStep={setStep} shopToChangePlan={shopToChangePlan}/>
            <PlanSelector title={PlanSelectorEnum.PRO} description="Ideal for advanced insights into sales trends, optimizing inventory levels and orders." price="99" details={['Unlimited editors', 'Stock management', 'Consumption tracking', 'BI Dashboard', 'AI forecasting']} selected={selectedPlan} setSelected={handleSelectedPlan} setStep={setStep} shopToChangePlan={shopToChangePlan}/>
          </div>
          </div>
      }
        <PageHierarchy />

        <div className="shop-management__main-counter">
            <div className="shop-management__main-counter__label">
                All your shops
            </div>
            <div className="shop-management__main-counter__value">
                {totalShops}
            </div>
        </div>
        <div className="shop-management__preview-table">
          <ShopTable setNewFlavorsPopup={setIsPopupOpen} setShopIdToDelete={setShopIdToDelete} setWordToConfirm={setWordToConfirm} />
        </div>
        {showShopPopup && (
            <NewShopPopup fullCommentary="fff" isVisible={isPopupOpen} setVisible={setIsPopupOpen} subscriptionId={subscriptionId} step={step} setStep={setStep} shopToEditId={shopToEditId} />
        )}
        {wordToConfirm && shopIdToDelete && 
          <ConfirmationPopup
            wordToConfirm={wordToConfirm}
            setWordToConfirm={setWordToConfirm}
            actionText='Are you sure you want to delete this shop ?'
            actionDetail='Your Stripe subscription linked to this shop will end'
            fncOnConfirm={deleteShop}
            fncArgs={{shopId:shopIdToDelete, userId:user.sub}}
            />
        }
    </div>
  );
};

export default ShopManagement;
